

export const url = "https://tech-wave-backend-server.onrender.com"